import { InsuranceDetailsType } from '@frontend/api-insurance-detail';
import { useAppScopeStore } from '@frontend/scope';

export const useGetLocationVerticalForPayerList = (locationId: string) => {
  const { accessibleLocationData } = useAppScopeStore();

  const locationData = accessibleLocationData?.[locationId || ''];

  const isWellnessVertical = locationData?.vertical?.toLowerCase() === 'wellness';
  const isDental = locationData?.vertical?.toLowerCase() === 'dental';
  const payerListVertical = isWellnessVertical
    ? InsuranceDetailsType.PayerVertical.MEDICAL
    : InsuranceDetailsType.PayerVertical.DENTAL;

  return { locationVerticalForPayerList: payerListVertical, isWellnessVertical, isDental };
};
